import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { NGXLogger } from 'ngx-logger';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private authSvc: AuthService,
    private logger: NGXLogger) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // TODO: refresh token 을 사용하여, 자동으로 인증을 연장하는 기능을 추가할 것.
    return next.handle(request)
      .pipe(
        catchError(err => {
          if (err.status === 401) {
            // 인증한 상태에서 401을 받았다면
            if (this.authSvc.isAuthenticated()) {
              this.logger.warn('error.interceptor', request);
              // Refresh Token이 실패했다면 다시 로그인을 해야 함.
              if (request.url.endsWith('/api/Token')) {
                this.handleAuthFail();
              } else {
                // 기타 API Call 에서 오류가 발생한 경우, Refresh Token을 이용해 연장을 시도.
                return this.authSvc.refreshToken()
                  .pipe(
                    // Refresh Token으로 인증 연장에 성공한 뒤, 기존의 요청을 재시도.
                    mergeMap((t: any) => {
                      const authReq = request.clone({ headers: request.headers.set('authorization', 'Bearer ' + this.authSvc.currentUserValue.token) });
                      return next.handle(authReq);
                    })
                  );
              }
            } else {
              // 인증하지 않은 상태에서 401을 받았다면, 인증 절차의 실패 문제이므로, 페이지 유지 후 상태를 알림.
              if (request.url.endsWith('/api/Auth')) {
                let message = err.error;
                if (message.title != undefined) {
                  message = message.title;
                }
                this.openSnackBar(`${message}`, null);
              } else {
                // 원인 불명의 경우, 초기화면으로 이동.
                this.handleAuthFail();
              }
            }
          }

          const error = err.error.message || err.statusText;
          return throwError(error);
        }))
  }

  private handleAuthFail() {
    this.authSvc.logout();
    this.openSnackBar('다시 로그인해 주세요.', null);
    this.router.navigate(['/account/log-in']);
  }

  private openSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
          duration: 2000,
      });
  }
}